export default {
    props: {
        pdfAuthor: {
            type: String,
            default: undefined,
            kComposite: 'pdf.author'
        }, 
        pdfAvoidLinks: {
            type: [Boolean, String],
            default: undefined,
            kComposite: 'pdf.avoidLinks'
        }, 
        pdfCreator: {
            type: String,
            default: undefined,
            kComposite: 'pdf.creator'
        }, 
        pdfDate: {
            type: Date,
            default: undefined,
            kComposite: 'pdf.date'
        }, 
        pdfFileName: {
            type: String,
            default: undefined,
            kComposite: 'pdf.fileName'
        }, 
        pdfForceProxy: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.forceProxy'
        }, 
        pdfKeywords: {
            type: String,
            default: undefined,
            kComposite: 'pdf.keywords'
        }, 
        pdfLandscape: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.landscape'
        }, 
        pdfMarginBottom: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.bottom'
        }, 
        pdfMarginLeft: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.left'
        }, 
        pdfMarginRight: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.right'
        }, 
        pdfMarginTop: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.top'
        }, 
        pdfPaperSize: {
            type: [String, Array],
            default: undefined,
            kComposite: 'pdf.paperSize'
        }, 
        pdfProxyURL: {
            type: String,
            default: undefined,
            kComposite: 'pdf.proxyURL'
        }, 
        pdfProxyTarget: {
            type: String,
            default: undefined,
            kComposite: 'pdf.proxyTarget'
        }, 
        pdfSubject: {
            type: String,
            default: undefined,
            kComposite: 'pdf.subject'
        }, 
        pdfTitle: {
            type: String,
            default: undefined,
            kComposite: 'pdf.title'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-gantt-vue-wrapper/src/KendoGantt/Pdf.js